import CandidateProfilePictureManager from './CandidateProfilePictureManager.container';

export default CandidateProfilePictureManager;
